export default {
  path: '/extension',
  name: 'extension',
  component: () => import('@/modules/extension/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'eRank extension - SEO for Ecommerce',
      },
    ],
    title: 'eRank — extension',
  },
};
